import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { Tag } from "@chakra-ui/tag";
import { Text } from "@chakra-ui/react";
import { IndexadorForm } from "core/features/indexador/typings";
import { UnidadePaginateResponse } from "core/features/unidades/typings/unidade";
import colors from "core/resources/theme/colors";
import { useMemo } from "react";
import { Control } from "react-hook-form";
import { Cell } from "react-table";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";

interface CellItem extends Cell<UnidadePaginateResponse> {}

interface UseListagemFracoesColumnsProps {
  valor: number;
  form: IndexadorForm;
  control: Control<IndexadorForm, object>;
  enabledEdit: boolean;
}
function useListagemUnidadeColumns({
  valor,
  form,
  control,
  enabledEdit,
}: UseListagemFracoesColumnsProps) {
  return useMemo(() => {
    return [
      {
        Header: "Unidade",
        accessor: "unidade",
        Cell: ({ row: { original } }: CellItem) => (
          <div>
            {original.numero} -{" "}
            <Tag variant="outline" colorScheme="blue">
              Bloco/Quadra: {original.blocoQuadra?.nome}
            </Tag>
          </div>
        ),
      },
      {
        Header: () => <Text ml={"38px"}>Peso</Text>,
        accessor: "unidade.id",
        Cell: ({ row: { original } }: CellItem) => (
          <div key={original.id}>
            <Field
              name={`unidades.${original.id}`}
              control={control}
              render={({ field, isInvalid }) => (
                <InputMoney
                  value={field.value}
                  onChange={field.onChange}
                  isInvalid={isInvalid}
                  disabled={!enabledEdit}
                  placeholder="--"
                  maxValue={100}
                  decimalScale={2}
                  decimalsLimit={2}
                  backgroundColor={enabledEdit ? colors.blue100 : "transparent"}
                  style={{
                    textAlign: "center",
                    width: "120px",
                    borderColor: "#00000000",
                  }}
                />
              )}
            />
          </div>
        ),
      },
      {
        Header: "Valor Total",
        accessor: "",
        Cell: ({ row: { original } }: CellItem) => (
          <div key={original.id}>
            <Text>
              {form.unidades && form.unidades[original.id]
                ? "R$ " + formatCurrency(form.unidades[original.id] * valor)
                : "--"}
            </Text>
          </div>
        ),
      },
    ];
  }, [control, enabledEdit, form.unidades, valor]);
}

export default useListagemUnidadeColumns;
